// @mui material components
import Icon from "@mui/material/Icon";

// School Pages
import Home from "pages/School/Home";
import About from "pages/School/About";
import WhyChooseUs from "pages/School/WhyChooseUs";
import Academics from "pages/School/Academics";
import SchoolLife from "pages/School/SchoolLife";
import Admissions from "pages/School/Admissions";
import Gallery from "pages/School/Gallery";
import Contact from "pages/School/Contact";

const routes = [
  {
    name: "Home",
    icon: <Icon>home</Icon>,
    route: "/",
    component: <Home />,
  },
  {
    name: "About Us",
    icon: <Icon>info</Icon>,
    route: "/about",
    component: <About />,
  },
  {
    name: "Why Choose Us",
    icon: <Icon>star</Icon>,
    route: "/why-choose-us",
    component: <WhyChooseUs />,
  },
  {
    name: "Academics",
    icon: <Icon>school</Icon>,
    collapse: [
      {
        name: "Academics",
        route: "/academics",
        component: <Academics />,
      },
      {
        name: "School Life",
        route: "/school-life",
        component: <SchoolLife />,
      },
    ],
  },
  {
    name: "Admissions",
    icon: <Icon>assignment</Icon>,
    route: "/admissions",
    component: <Admissions />,
  },
  {
    name: "Gallery",
    icon: <Icon>photo_library</Icon>,
    route: "/gallery",
    component: <Gallery />,
  },
  {
    name: "Contact Us",
    icon: <Icon>contact_mail</Icon>,
    route: "/contact",
    component: <Contact />,
  },
];

export default routes;
